import React from 'react';

import {
  TotalMoreInfoIcon,
  FeeInformationIcon,
  TotalBookAVisitOrTourIcon,
  TotalCheckForVacanciesIcon,
  TotalEnquiriesIcon,
} from 'components/common/SVGIcon';

import SummaryCard from 'components/common/SummaryCardCustom';
import { getEnquiriesSummaryData } from 'redux/contacts/selectors';
import { useSelector } from 'react-redux';
import { EnquiriesSummaryCardSpace } from '../styles';

const EnquiriesSummary = () => {
  const summaries = useSelector(getEnquiriesSummaryData) || {};

  const enquiriesSummary = [
    {
      title: 'contacts.enquiriesSummary.totalEnquiries',
      count: summaries.totalEnquiries,
      IconComponent: TotalEnquiriesIcon,
    },
    {
      title: 'contacts.enquiriesSummary.moreInformation',
      count: summaries.moreInformationEnquiries,
      IconComponent: TotalMoreInfoIcon,
    },
    {
      title: 'contacts.enquiriesSummary.checkForVacancies',
      count: summaries.checkForVacanciesEnquiries,
      IconComponent: TotalCheckForVacanciesIcon,
    },
    {
      title: 'contacts.enquiriesSummary.bookATourOrVisit',
      count: summaries.bookATourOrVisitEnquiries,
      IconComponent: TotalBookAVisitOrTourIcon,
    },
    {
      title: 'contacts.enquiriesSummary.feeInformation',
      count: summaries.feeInformationEnquiries,
      IconComponent: FeeInformationIcon,
    },
  ];

  return (
    <EnquiriesSummaryCardSpace size={[20, 20]} className="py-16 px-24" wrap>
      {enquiriesSummary.map((item, index) => (
        <SummaryCard {...item} key={index} />
      ))}
    </EnquiriesSummaryCardSpace>
  );
};

export default EnquiriesSummary;
